import { useCallback } from "react";
import { useQueryClient, useIsFetching } from "@tanstack/react-query";
import { cancelProgressiveQuery, isProgressiveQuery, isProgressiveQueryFetchingMore } from "./progressive-query-utils";
import { DATA_QUERY_KEY } from "../../../core";
export function useCancelInProgressDataQueries() {
    const queryClient = useQueryClient();
    const isFetching = useIsFetching();
    const cancelInProgressDataQueries = useCallback(async ()=>{
        await queryClient.cancelQueries({
            queryKey: [
                DATA_QUERY_KEY
            ],
            type: 'active',
            predicate: (query)=>{
                // Normal fetching status.
                const isFetching = query.state.fetchStatus === 'fetching';
                if (isProgressiveQuery(query)) {
                    if (isFetching || isProgressiveQueryFetchingMore(query)) {
                        cancelProgressiveQuery(queryClient, query);
                        return true;
                    }
                }
                // Basic queries can just return `true` here to cancel and react-query handles the rest
                // for us.
                return isFetching;
            }
        });
    }, [
        queryClient
    ]);
    return {
        isFetching,
        cancelInProgressDataQueries
    };
}

//# sourceMappingURL=cancel-queries.js.map